// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"03aff40a","232":"453f19d9","348":"2f7610a6","391":"42f766ae","489":"f3b6f17e","496":"c2e78119","516":"fc177dc7","667":"33923d2f","826":"8a89546e","872":"e40721a4"}[chunkId] + ".chunk.js";
};